/* auto-generated: @mui/icons-material */
import Base from '@mui/icons-material/PersonAdd';
import {withMuiAdapter} from '@common/icons/with-mui-adapter';

export const PersonAddIcon = withMuiAdapter(Base, 'PersonAdd');
